@if (initialized) {
  <div class="text-center mb-4">
    <div class="mb-4">
      <p-button styleClass="w-5rem bg-cyan-500 border-none" icon="pi pi-phone p-button-icon text-4xl p-1"></p-button>
    </div>
    <div class="flex flex-column gap-2">
      <div class="text-color text-2xl font-semibold mb-2">Ein Anruf genügt!</div>
      <div class="text-color-secondary text-base">Scanne den QR-Code mit deinem Mobiltelefon, um uns anzurufen.</div>
      <!--  needs to display number from backend-->
      @if (phoneUrl) {
        <div class="col-12 text-center">
          <qrcode [qrdata]="phoneUrl" [width]="180"></qrcode>
        </div>
      }
<!--      <div class="text-primary text-xl mt-3 font-medium">{{ phone | phoneFormat}}</div>-->
      <div class="text-primary underline text-xl mt-3 font-medium">
        <a [href]="phoneUrl">{{ phone | phoneFormat }}</a>
      </div>
    </div>


  </div>

}
